import { observer } from 'mobx-react';
import { MiniBanner } from '../../components/MiniBanner';
import { useStores } from '../../hooks';

import styles from './styles/main.module.scss';

export const MiniBannerContainer = observer(() => {
  const { loyaltyStore } = useStores();

  const { displayTutorial } = loyaltyStore;

  if (displayTutorial !== true) return null;

  return (
    <section className={styles.mini_banner_container}>
      <div className="container">
        <MiniBanner
          text="Программа лояльности"
          badgeText="NEW"
          buttonText="Узнать больше"
          scrollToId="loyalty-program"
        />
      </div>
    </section>
  );
});
